import { render } from "./ForgeSuggestionDraft.vue?vue&type=template&id=21af3e0e&scoped=true&ts=true"
import script from "./ForgeSuggestionDraft.vue?vue&type=script&lang=ts"
export * from "./ForgeSuggestionDraft.vue?vue&type=script&lang=ts"

import "./ForgeSuggestionDraft.vue?vue&type=style&index=0&id=21af3e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21af3e0e"]])

export default __exports__